export const getKeyByValue = (object, value) => {
  return Object.keys(object).find((key) => object[key] === value);
};

export const translate = (string) => {
  let newString = "";

  switch (string) {
    case "kupsetamise_temperatuur":
      newString = "Küpsetamise temperatuur";
      break;

    case "kupsetusaeg":
      newString = "Küpsetus- aeg";
      break;

    case "arv_kastis":
      newString = "Arv kastis";
      break;

    default:
      newString = string;
      break;
  }
  //if(){}

  return newString;
};


